import { version } from '../../../package.json'

const Version = () => {
	return <div className='acnf-agro-version'>Versão {version}</div>
}

export { Version }
